export default __webpack_public_path__ + "static/linea3-preview-1-b9fbecd0b2d96a4ead1990af5715e749.png";